import { languageService } from "../../../Language/language.service";

export const materialTypeListSectionSchema = () => ({
  title: "Add/Edit Material Type",
  id: "materialListSectionSchema",
  stateTitle: {
    create: languageService("Add Material Type"),
    edit: languageService("Edit Material Type"),
  },
  sections: [
    {
      id: "materialInfoSection",
      fields: [
        {
          id: "desc", // required
          labelValue: languageService("Description"),
          required: true,

          col: 4,
        },
        {
          id: "Item No", // required
          type: "input", // required

          labelValue: languageService("Item No."),
          required: true,

          col: 4,
        },

        {
          id: "UM", // required
          type: "input", // required
          //type: "select", // required
          //selectOptions:[],
          labelValue: languageService("Unit"),
          required: true,

          col: 4,
        },
      ],
    },

    {
      id: "materialInfoFormButtonsSection",
      fields: [
        {
          id: "addMaterialType", // required
          type: "button", // required
          labelValue: languageService("Add"),
          action: "submit",
          callback: "addMaterialType",
          position: "footer",
          hiddenStates: ["edit"],
          col: 6,
        },
        {
          id: "updateMaterialType", // required
          type: "button", // required
          labelValue: languageService("Update"),
          action: "submit",
          callback: "updateMaterialType",
          position: "footer",
          hiddenStates: ["create"],
          col: 6,
        },
        {
          id: "cancelEquipmentDialog", // required
          type: "button", // required
          labelValue: languageService("Cancel"),
          action: "cancel",
          position: "footer",
          col: 6,
        },
      ],
    },
  ],
});



// WEBPACK FOOTER //
// ./src/components/MaterialTypeListView/materialTypeSection/materialTypeSectionSchema.js